import { AppService } from './../services/app.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'

})
export class ItemTrackingESService {
  userName = localStorage.userDetails.email;
  readonly item_es_apiBaseURL = "https://analysis.moglix.com/item_tracking/get_team_mapping";
  dd = {};
  userDetails :Object = {};
  headers = [];
  finalresult = {};
  responseList = [];
  responseListExcel = [];
  finalDataObject: any;
  constructor(private http: HttpClient, private appService: AppService) { 
    this.userDetails = JSON.parse(localStorage.getItem('userDetails')) || {};
  }
  getDateItemTrackingES() {
    return this.http.get('https://analysis.moglix.com/' + "item_tracking/get_date_limit");
  }
  get_otif_date_limit() {
    return this.http.get('https://analysis.moglix.com/' + "item_tracking/get_otif_date_limit");

  }
  getFiltersItemTrackingES(userId_val) {
    return this.http.post(environment.baseURL_FREQ+"broad_mapping",{"username":userId_val});
  }

  sendPostRequest(url, requestbody) {
    requestbody['username'] = this.userDetails['email'];
    return this.http.post(url, requestbody)

  }
  getESDrillDown(url, request) {
    request['username'] = this.userDetails['email'];
    return this.http.post(url, request);
  }
  getdd() {
    return this.dd = { "data": { "aggregate_data": [{ "Days Remaining": "< 00 days", "Delivered": { "item_count": 13, "item_value": 267448 }, "Delivered POD": { "item_count": 49, "item_value": 1118243 }, "Invoiced": { "item_count": 32, "item_value": 243194 }, "MRN Done": { "item_count": 12, "item_value": 2549121 }, "New Item in EMS": { "item_count": 0, "item_value": 0 }, "Shipped": { "item_count": 41, "item_value": 225028 }, "Supplier PO Created": { "item_count": 36, "item_value": 2124875 } }, { "Days Remaining": "00 - 02 days", "Delivered": { "item_count": 0, "item_value": 0 }, "Delivered POD": { "item_count": 0, "item_value": 0 }, "Invoiced": { "item_count": 0, "item_value": 0 }, "MRN Done": { "item_count": 0, "item_value": 0 }, "New Item in EMS": { "item_count": 0, "item_value": 0 }, "Shipped": { "item_count": 0, "item_value": 0 }, "Supplier PO Created": { "item_count": 0, "item_value": 0 } }, { "Days Remaining": "02 - 05 days", "Delivered": { "item_count": 0, "item_value": 0 }, "Delivered POD": { "item_count": 0, "item_value": 0 }, "Invoiced": { "item_count": 0, "item_value": 0 }, "MRN Done": { "item_count": 0, "item_value": 0 }, "New Item in EMS": { "item_count": 0, "item_value": 0 }, "Shipped": { "item_count": 0, "item_value": 0 }, "Supplier PO Created": { "item_count": 0, "item_value": 0 } }, { "Days Remaining": "05 - 10 days", "Delivered": { "item_count": 0, "item_value": 0 }, "Delivered POD": { "item_count": 0, "item_value": 0 }, "Invoiced": { "item_count": 0, "item_value": 0 }, "MRN Done": { "item_count": 0, "item_value": 0 }, "New Item in EMS": { "item_count": 0, "item_value": 0 }, "Shipped": { "item_count": 0, "item_value": 0 }, "Supplier PO Created": { "item_count": 1, "item_value": 97000 } }, { "Days Remaining": "> 10 days", "Delivered": { "item_count": 0, "item_value": 0 }, "Delivered POD": { "item_count": 0, "item_value": 0 }, "Invoiced": { "item_count": 1, "item_value": 2743 }, "MRN Done": { "item_count": 0, "item_value": 0 }, "New Item in EMS": { "item_count": 0, "item_value": 0 }, "Shipped": { "item_count": 0, "item_value": 0 }, "Supplier PO Created": { "item_count": 3, "item_value": 123480 } }, { "Days Remaining": "Due Date Not Available", "Delivered": { "item_count": 0, "item_value": 0 }, "Delivered POD": { "item_count": 16, "item_value": 99156 }, "Invoiced": { "item_count": 8, "item_value": 207529 }, "MRN Done": { "item_count": 2, "item_value": 414095 }, "New Item in EMS": { "item_count": 0, "item_value": 0 }, "Shipped": { "item_count": 1, "item_value": 28632 }, "Supplier PO Created": { "item_count": 29, "item_value": 4988533 } }], "delivered_percentage": "15 %", "headers": ["Days Remaining", "New Item in EMS", "Supplier PO Created", "Invoiced", "MRN Done", "Shipped", "Delivered", "Delivered POD"], "otif": "52 %" }, "message": "Aggregate data fetched successfully", "status": "success" };
  }
  getOTIFViewDetails(url,requestbody){
    return this.http.post('https://analytics.moglix.com/' + url,requestbody);
  }
   getOTIFViewDetailsTable(url,requestbody){
    return this.http.post('https://analysis.moglix.com/' + url,requestbody);
  }
  getotifTrendingLine(url, payload) {
    return this.http.post(url, payload);
  }

  post(finalpostObj) {
    this.headers = [];
    this.finalresult = [];
    this.responseList = [];
    this.responseListExcel = [];
    this.headers = finalpostObj['headers'];
    this.finalresult = finalpostObj['result'];
    this.finalDataObject = this.sortedResponseList(this.finalresult);
    if (this.finalDataObject)
      return this.finalDataObject
}

sortedResponseList(finalresult) {
  for (var i in finalresult) {
    var obj = finalresult[i];
    let orderObject = {};
    let orderobjectwithoutcomma = {}
    for (var j in this.headers) {
      for (const key of Object.keys(obj)) {
        if (this.headers[j] == key) {
          orderObject[key] = obj[key].toLocaleString();
          let regExp = /^\d*(\.)?(\d{0,10})?$/ 
          if(regExp.test(obj[key]))
               orderobjectwithoutcomma[key] = obj[key];
            else
              orderobjectwithoutcomma[key] = obj[key];
        }
      }
    }
    this.responseList.push(orderObject);
    this.responseListExcel.push(orderobjectwithoutcomma);

  }
  if (this.responseList)
  if (this.responseList && this.responseListExcel)
    this.finalDataObject = { excel: this.responseListExcel };
  return this.finalDataObject;
}

}
